module.exports = __webpack_public_path__ + "static/media/loadingup2.08d08dd1.jpg";